import React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { Container } from '@mui/system';
import useAusstellungen from '../Hooks/useAusstellungen';
import bild from './Zeitungsartikel_WP_2025-02-17.jpg';

const Ausstellungen = () => {
	const ausstellungen = useAusstellungen();

    return <div>
        <h2>Ausstellungen</h2>

        <Container maxWidth='sm'>
            <img src={bild} alt="Zeitungsartikel" style={{ width: '100%', marginBottom: '20px' }} />
            <TableContainer component={Paper}>
                <Table aria-label="simple table">
                    <TableHead>
                    </TableHead>
                    <TableBody>
                    {ausstellungen.map((row) => (
                        <TableRow
                        key={row.zeit}
                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                        >
                            <TableCell component="th" scope="row">
                                {row.zeit}
                            </TableCell>
                            <TableCell align="right">
                                {row.inhalt}
                            </TableCell>
                        </TableRow>
                    ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </Container>
    </div>
}

export default Ausstellungen